// Glas-Tooltip (Handoff Tickets §8) – reine Logik: Text „Titel – Beschreibung“ teilen und Position bestimmen.

export interface TooltipTeile {
  titel: string;
  /** null, wenn der Text keinen „ – “-Trenner hat */
  beschreibung: string | null;
}

/** Am ERSTEN „ – “ (Halbgeviertstrich mit Leerzeichen) teilen: fetter Titel + Beschreibung. */
export function teileTooltip(text: string): TooltipTeile {
  const t = text.trim();
  const m = /\s–(\s|$)/.exec(t);
  if (!m || m.index <= 0) return { titel: t, beschreibung: null };
  const beschreibung = t.slice(m.index + m[0].length).trim();
  return { titel: t.slice(0, m.index).trim(), beschreibung: beschreibung || null };
}

export interface TooltipPosition {
  /** Mitte des Tooltips (px vom linken Rand) */
  x: number;
  /** Ankerlinie: Oberkante-10 (oben) bzw. Unterkante+10 (unten) */
  y: number;
  oben: boolean;
}

/**
 * Prototyp: x = Elementmitte, begrenzt auf [150, vw−150]; liegt das Element tiefer als 110 px,
 * steht der Tooltip darüber, sonst darunter.
 */
export function tooltipPosition(r: { left: number; top: number; width: number; bottom: number }, vw: number): TooltipPosition {
  const mitte = r.left + r.width / 2;
  const x = vw <= 300 ? vw / 2 : Math.min(Math.max(mitte, 150), vw - 150);
  const oben = r.top > 110;
  return { x, y: oben ? r.top - 10 : r.bottom + 10, oben };
}
